import { useCallback, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTeleQuery } from './useTeleQuery';
import { useZipcode } from './useZipcodeQuery';
import { useOptions } from './useOptions';
import { handleSubmitForm } from '../function/submitHandler';
import { onUploadFile } from './onUploadFile';
import {
  breakdownSubsQuery,
  mobilesQuery,
} from '../../../../services/react-query/optionMasterQuery';

export const useGetClaimAddList = () => {
  const { control, setValue, getValues, watch, reset, handleSubmit } = useForm({
    isCreateNewAddress: '',
  });
  const fullName = watch('fullName');
  const isCreateNewAddress = watch('isCreateNewAddress');

  const selectedWarranty = watch('warrantyId');
  const { mutate: onCallTele, loading: isLoadingTele } = useTeleQuery({ reset, getValues });
  const { mutate: onCallZipCode, loading: isLoadingZipCode } = useZipcode({ reset, getValues });
  const { mutate: onAddClaim, loading: isLoadingToSave } = onUploadFile();

  const {
    addressFullOptions,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    addressData,
    warrantyOptions,
    breakdownOptions,
    selectedBreakdown,
  } = useOptions({
    watch,
  });

  const { data: breakdownSubsAll, isLoading: isLoadingBreakdownSubs } = breakdownSubsQuery({
    productType: selectedBreakdown,
  });

  // API กรองมาแค่ระดับ productType ต้องกรองด้วยอาการเสียหลักอีกชั้น
  // ไม่งั้นเลือกย่อยข้ามอาการหลักได้ แล้วไปโดน backend ปฏิเสธตอนกดบันทึก
  const selectedBreakdownId = watch('breakdownId');
  const breakdownSubsOptions = useMemo(
    () => (breakdownSubsAll ?? []).filter((item) => item.breakdownId === selectedBreakdownId),
    [breakdownSubsAll, selectedBreakdownId],
  );
  const { data: mobilesOptions, isLoading: isLoadingMobiles } = mobilesQuery(selectedWarranty);

  const onEnterHandler = useCallback(
    async (value, item) => {
      switch (item?.name) {
        case 'telephone':
          reset({ telephone: getValues('telephone') });
          onCallTele(value);
          break;
        case 'zipcode':
          onCallZipCode(value);
          break;
        default:
          break;
      }
    },
    [getValues],
  );
  const onChangeAddress = (value) => {
    const addressSetNew = addressData?.find((item) => item?.customerAddressId === value);
    if (addressSetNew) {
      setValue('zipcode', addressSetNew?.zipcode);
      setValue('provinceId', {
        value: addressSetNew?.provinceId,
        label: addressSetNew?.provinceName,
      });
      setValue('districtId', {
        value: addressSetNew?.districtId,
        label: addressSetNew?.districtName,
      });
      setValue('subDistrictId', {
        value: addressSetNew?.subDistrictId,
        label: addressSetNew?.subDistrictName,
      });
      setValue('other', addressSetNew?.other);
    }
  };

  const onSubmit = (values) => {
    const valuesWithCustomerCode = {
      ...values,
      provinceId:
        typeof values.provinceId === 'object' ? values.provinceId.value : values.provinceId,
      districtId:
        typeof values.districtId === 'object' ? values.districtId.value : values.districtId,
      subDistrictId:
        typeof values.subDistrictId === 'object'
          ? values.subDistrictId.value
          : values.subDistrictId,
    };
    handleSubmitForm(valuesWithCustomerCode, onAddClaim);
  };

  useEffect(() => {
    setValue('zipcode', '');
    setValue('provinceId', '');
    setValue('districtId', '');
    setValue('subDistrictId', '');
    setValue('other', '');
    setValue('customerAddressId', '');
  }, [isCreateNewAddress]);

  const onChangeProduct = (value, item) => {
    switch (item?.name) {
      case 'warrantyId':
        setValue('breakdownId', '');
        setValue('breakdownSubId', '');
        setValue('warrantyMobileIds', []);
        setValue('warrantyMobileOtherReason', '');
        break;
      case 'warrantyMobileIds':
        if (!Array.isArray(value) || !value.some((v) => v == -1)) {
          setValue('warrantyMobileOtherReason', '');
        }
        break;
      case 'breakdownId':
        setValue('breakdownSubId', '');
        break;
      default:
        break;
    }
  };

  return {
    control,
    setValue,
    getValues,
    fullName,
    watch,
    onEnterHandler,
    addressFullOptions,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    warrantyOptions,
    breakdownOptions,
    onChangeAddress,
    onSubmit,
    handleSubmit,
    isLoadingToSave,
    isLoadingTele,
    isLoadingZipCode,
    addressData,
    isCreateNewAddress,
    handleSubmit,
    breakdownSubsOptions,
    isLoadingBreakdownSubs,
    onChangeProduct,
    mobilesOptions,
    isLoadingMobiles,
  };
};
